import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';
import {notify} from '../../helpers/utility';

// CallParkStatus

export const callStatusStart = () => {
  return {
    type: actionTypes.CALL_STATUS_START,
  };
};

export const callStatusFail = (error) => {
  return {
    type: actionTypes.CALL_STATUS_FAIL,
    error: error,
  };
};

export const callStatusSuccess = (parkDetails, confDetails) => {
  return {
    type: actionTypes.CALL_STATUS_SUCCESS,
    parkDetails: parkDetails,
    confDetails: confDetails
  };
};

export const parkCallStatus = (agentId) => {
  //console.log(agentId);
  return (dispatch) => {
    dispatch(callStatusStart());
    ctiRequest['CTI_CALL_PARK_STATUS'].agent_id = agentId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_CALL_PARK_STATUS'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_CALL_PARK_STATUS'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          //console.log(result.data.response.total_calls);
          dispatch(callStatusSuccess(result.data.response.park_details,result.data.response.conf_details));
        } else {
          notify('Call Parking Error: ' + result.data.response.reason, 'call-parking');
          dispatch(callStatusFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Call Parking Error', 'call-parking');
        dispatch(callStatusFail(err));
      });
  };
};


// CallPark

export const callParKStart = () => {
  return {
    type: actionTypes.CALL_PARK_START,
  };
};

export const callParkFail = (error) => {
  return {
    type: actionTypes.CALL_PARK_FAIL,
    error: error,
  };
};

export const callParkSuccess = () => {
  return {
    type: actionTypes.CALL_PARK_SUCCESS,
  };
};

export const callPark = (agentId, phoneNo) => {
  //console.log(agentId);
  return (dispatch) => {
    dispatch(callParKStart());
    ctiRequest['CTI_CALL_PARK'].agent_id = agentId;
    ctiRequest['CTI_CALL_PARK'].phone = phoneNo;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_CALL_PARK'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_CALL_PARK'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          //console.log(result.data.response.total_calls);
          dispatch(callParkSuccess(result.data.response.reason));
        } else {
          notify('Call Park Error: ' + result.data.response.reason, 'call-queue');
          dispatch(callParkFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Call Park Error', 'call-Park');
        dispatch(callParkFail(err));
      });
  };
};


// CallUnpark

export const callUnparkStart = () => {
  return {
    type: actionTypes.CALL_UNPARK_START,
  };
};

export const callUnParkFail = (error) => {
  return {
    type: actionTypes.CALL_UNPARK_FAIL,
    error: error,
  };
};

export const callUnParkSuccess = () => {
  return {
    type: actionTypes.CALL_UNPARK_SUCCESS,
  };
};

export const callUnPark = (agentId,parkId, phoneNo) => {
  //console.log(agentId);
  return (dispatch) => {
    dispatch(callUnparkStart());
    ctiRequest['CTI_CALL_UNPARK'].agent_id = agentId;
    ctiRequest['CTI_CALL_UNPARK'].call_park_id= parkId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_CALL_UNPARK'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_CALL_UNPARK'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          //console.log(result.data.response.total_calls);
          dispatch(callUnParkSuccess(result.data.response.agent_id));
        } else {
          notify('Call Park Error: ' + result.data.response.reason, 'call-park');
          dispatch(callUnParkFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Call Queue Error', 'call-park');
        dispatch(callUnParkFail(err));
      });
  };
};

